import { Period } from "./periods.enum"
import type { ReferentialCode } from "./referential"

export const COMMON_PERIOD_OPTIONS: ReferentialCode<Period>[] = [
  { code: Period.YEAR_TO_DATE, label: "Année - À date" },
  { code: Period.YEAR_ELAPSED_MONTH, label: "Année - Mois échu" },
  { code: Period.PREVIOUS_YEAR, label: "Année précédente" },
  { code: Period.CURRENT_MONTH, label: "Mois en cours" },
  { code: Period.LAST_MONTH, label: "Mois échu" },
  { code: Period.LAST_3_MONTHS, label: "3 derniers mois" },
  { code: Period.LAST_4_MONTHS, label: "4 derniers mois" },
  { code: Period.LAST_12_MONTHS, label: "12 derniers mois" },
]
